import React, { createContext, useContext } from 'react';

const SearchAbTestContext = createContext<{
    isVariant: boolean;
}>({
    isVariant: false,
});

export const useSearchAbTestContext = () => {
    const context = useContext(SearchAbTestContext);
    return context;
};

export const SearchAbTestProvider = ({ children }: React.PropsWithChildren<{}>) => {
    /*
    // Enable this when the AB test is ready to be used.
    const userId = useUserId(); 
    const { isVariant } = useAbTest({
        name: 'Future name of ab-test',
        userId,
        enabled: true,
    });
    */
    const obj = React.useMemo(() => ({ isVariant: false }), []);

    return <SearchAbTestContext.Provider value={obj}>{children}</SearchAbTestContext.Provider>;
};
